import { Command } from '@nest/internal-frontend';
import { SearchIcon } from 'lucide-react';
import { useNavigate } from 'react-router';

export const useCommandOpenScanPackagePage = (): Command => {
	const navigate = useNavigate();

	return {
		id: 'open-scan-package-page',
		label: 'Informace o balíku z nákladního listu',
		icon: <SearchIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: undefined,
		loading: undefined,
		run: async () => {
			navigate('/consignment-notes/scan-package');
		}
	};
};
